// extracted by mini-css-extract-plugin
export default {"root":"ActionsProfileMenu_root__6BtLi","top":"ActionsProfileMenu_top__k1e6i","middle":"ActionsProfileMenu_middle__HmIBf","bottom":"ActionsProfileMenu_bottom__MsLT6"};